<script lang="ts">
    import type {Rec} from 'src/typings';
    import type {DatatypedFilterDefinition} from '../../types';
    import {resolveDatatypeEditorForceSettings} from './datatype-editor-settings-resolver';
    import {exists, uuid} from 'shared/utils/custom-utils';
    import {getSearchFieldTypeFiltersContext} from '../../search-field-type-filters.context';
    import {createFilterButtonsContext, FILTER_BY_DEFAULT_EVENT} from './filter-buttons.context';
    import {get} from 'svelte/store';
    import KpValueEditor from 'shared/value-editors/kp-value-editor/KpValueEditor.svelte';
    import KpValueEditorForceSettings from 'shared/value-editors/kp-value-editor-force-settings/KpValueEditorForceSettings.svelte';
    import FilterButtons from './FilterButtons.svelte';

    export let filterableDatatypeDefinition: DatatypedFilterDefinition;

    const context = getSearchFieldTypeFiltersContext();
    const filterButtonsContext = createFilterButtonsContext();
    const editorForceSettings = resolveDatatypeEditorForceSettings(filterableDatatypeDefinition.datatype);
    const editorId = uuid();

    let model = resolveCurrentModel();
    let filteredData: { filterParam: string; value: any } | null = null;

    function resolveCurrentModel(): any {
        const filteredValues = get(context.filteredValues$);
        return filteredValues[filterableDatatypeDefinition.fieldName]?.val ?? null;
    }

    const handleModelChange = (event: CustomEvent<Rec>) => {
        if (!exists(event.detail)) {
            filteredData = null;
            return;
        }

        filteredData = {
            filterParam: filterableDatatypeDefinition.fieldName,
            value: event.detail
        };
    };

    const handleSubmit = () => {
        filterButtonsContext.eventBus.dispatchEvent(new CustomEvent(FILTER_BY_DEFAULT_EVENT));
    }
</script>

<form on:submit|preventDefault={handleSubmit}>
    <KpValueEditorForceSettings forceSettings={[editorForceSettings]}>
        <KpValueEditor {editorId}
                       editorName={filterableDatatypeDefinition.fieldName}
                       type={editorForceSettings.type}
                       on:model-change={handleModelChange}
                       bind:model/>
    </KpValueEditorForceSettings>
</form>

{#if exists($$slots.filterButtons)}
    <FilterButtons {filterableDatatypeDefinition}
                   value={filteredData?.value}
                   let:value>

        <slot name="filterButtons" {filterableDatatypeDefinition} {value}/>
    </FilterButtons>
{:else}
    <FilterButtons {filterableDatatypeDefinition} value={filteredData?.value}/>
{/if}